import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ErrorCardSVG from '../../assets/images/errorCard/ErrorCardSVG';
import { ROUTES_PATH } from '../../constants';
import {
  ButtonAdd,
  CardErrorButton,
  CardInfo,
  ErrorCardTextWrapper,
} from './ErrorCardStyledComponent';
import { PaymentSelectorEnum } from '../../interfaces/Payment';
import { usePaymentCard } from '../../contexts/PaymentCardContext';
import { TextRegular, Title } from '../../styles/GlobalStyledComponents';
import PostMessageService from '../../services/PostMessage';
import { useMerchant } from '../../contexts/MerchantContext';
import { useCreditProposalResult } from '../../contexts/CreditProposalResultContext';

interface ErrorCardProps {
  paymentMethod?: PaymentSelectorEnum | null;
  loadingEvent?: any;
  cardExist?: any;
  buttonClick: (data: boolean) => void;
}

export const ErrorCard = ({
  paymentMethod,
  // loadingEvent,
  cardExist,
  buttonClick,
}: ErrorCardProps) => {
  const { paymentCards } = usePaymentCard();
  const { isPostDataMessages } = useMerchant();
  const { creditProposalResult } = useCreditProposalResult();

  const returnToPayment = () => {
    buttonClick(true);
  };

  useEffect(() => {
    if (isPostDataMessages && creditProposalResult) {
      PostMessageService.PaymentFailed(creditProposalResult.credit_proposal_id);
    }
  }, []);

  return (
    <CardInfo>
      <ErrorCardSVG />
      <ErrorCardTextWrapper>
        <Title>¡Ups!</Title>
        {paymentMethod === PaymentSelectorEnum.EXPRESS ? (
          <TextRegular $fontSize={14} $align="center">
            No se ha podido reutilizar tu tarjeta.
          </TextRegular>
        ) : (
          <TextRegular $fontSize={14} $align="center">
            Ha ocurrido un problema y no hemos podido ejecutar el pago. Prueba
            con una forma de pago distinta.
          </TextRegular>
        )}
      </ErrorCardTextWrapper>
      <CardErrorButton>
        <ButtonAdd onClick={returnToPayment}>
          {paymentCards?.length === 0 ? 'Elegir otra tarjeta' : 'Volver'}
        </ButtonAdd>
      </CardErrorButton>
    </CardInfo>
  );
};
